import React, { useEffect, useState } from 'react'
import GroupSliderInfo from '../../../pages/dashboard/tradingGroup/GroupSlideInfo';
import { errorNotifier, successNotifier } from '../../..';
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Text, Tooltip, useColorModeValue,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  Button,
  PopoverBody,
  Stack,
} from '@chakra-ui/react';
import { addSingleUserToGroup, checkout, deleteGroup, getOtherUsersNotInGroup, joinGroup } from '../../../pages/dashboard/tradingGroup/service';
import { useGetState } from '../../../context/useGetState';
import { nFormatter } from '../ProfileOverview';
import { BsLink45Deg } from 'react-icons/bs';
import { IoMdLink, IoMdSettings } from 'react-icons/io';
import AddMembersModal from '../../../pages/dashboard/tradingGroup/AddMembersModal';
import { AUTH_ROUTES } from '../../../service/routes.constants';
import DeleteGroupModal from './DeleteGroupModal';
import GroupShareButton from './GroupShareButton';
import ShareGroupModal from './ShareGroupModal';

// Function to generate a slug from text
const slugify = (text) => {
  return text.toLowerCase().replace(/ /g, "-");
};

const MyGroupCard = ({group, authUser, profileInfo}) => {
  const [updatedGroup, setUpdatedGroup] = useState(group);
  const [groupSlideInfoModalOpen, setGroupSlideInfoModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [otherUsers, setOtherUsers] = useState([]);
  const [addMembersModalOpen, setAddMembersModalOpen] = useState(false);
  const [deleteGroupModalOpen, setDeleteGroupModalOpen] = useState(false);
  const [shareGroupModalOpen, setShareGroupModalOpen] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const { state } = useGetState();
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const borderColor = useColorModeValue("#181818", "#707070");
  const textColor4 = useColorModeValue("#656464", "#FCFCFC");

  //console.log('userInfo: ', userInfo)

  const navigate = useNavigate()

  /////share
  
  ////////////

  useEffect(() => {
    const fetchOtherUsersData = async () => {
      try {
        const othersRes = await getOtherUsersNotInGroup(updatedGroup?.id);
        //console.log('others: ',othersRes?.data?.data);
        setOtherUsers(othersRes?.data?.data)
      } catch (error) {
        console.log('error: ', error);
      }
    }
    fetchOtherUsersData();
  }, []);

  const handleGroupDelete = (selectedGroup) => {
    try {
      const res = deleteGroup(selectedGroup?.id);
      setLoading(false);
      successNotifier(`Successfully Deleted ${selectedGroup?.name}`);
    } catch (error) {
      console.log('error: ', error);
    }
  }

  //Add members
  const handleAddMember = async (usersToAdd) => {
        
    //const res = await follow(userIdToRemove, setBtnLoading)
    //console.log('handleAddMember: ', '["1","2","3"]');
    
  };

  const handleAddSingleMember = async (selectedMember) => {
    try {
      let res = await addSingleUserToGroup(updatedGroup?.id, selectedMember?.id);
      setLoading(false);

      // Create a new array that excludes selectedMember
      const updatedOtherUsers = otherUsers.filter(
        (user) => user.id !== selectedMember.id
      );

      // Update the state with the new array
      setOtherUsers(updatedOtherUsers);

      successNotifier(`Successfully Added Member To ${updatedGroup?.name}`);
      setAddMembersModalOpen(false)
    
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const handleSubmit = async (groupType) => {
    if (groupType === "paid") {
      setGroupSlideInfoModalOpen(true)
    } else {
      setLoading(true);
      await joinGroup(group?.invite_link)
        .then((data) => {
          setLoading(false);
          setUpdatedGroup(data?.data)
          successNotifier(`Successfully joined ${data?.data?.name} group`);
          //console.log('groupdata:',data?.data);
          navigate("/groups");
        })
        .catch((e) => {
          const notSubscribed = e?.response?.data?.errors?.no_subscription;
          const expiedSubscription = e?.response?.data?.errors?.subscription_expired;
          const trialPeriodOver = e?.response?.data?.errors?.trial_period_over;
          setLoading(false);
          // errorNotifier(`${e?.response?.data?.message}, initializing payment...`);
          // return;
          if (notSubscribed || expiedSubscription || trialPeriodOver) {
            let accountType = state?.authUser?.account_type;
            checkout(accountType, group?.id)
              .then((res) => {
                let clientSecret = res?.data?.client_secret;
                errorNotifier(`${e?.response?.data?.message}...`);
  
                setClientSecret(clientSecret);
                setShowPaymentForm(true);
              })
              .catch((res) => errorNotifier(res?.response?.data?.message));
          } else {
            errorNotifier(`${e?.response?.data?.message}`);
          }
        });
    }
    
  };

  const handleCopyToClipboard = () => {
    const textToCopy = `${group?.invite_link}`;

    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        // Text successfully copied to clipboard
        console.log("Text copied to clipboard: ", textToCopy);
      })
      .catch((error) => {
        console.error("Unable to copy text to clipboard: ", error);
      });
  };

  const slug = slugify(updatedGroup?.name)

  //store in state
  const gotoGroupEdit = (updatedGroup) => {
    //console.log('gotoGroup: ', 'gotoGroup');
    navigate(`/groups/${slug}`, { state: { groupData: updatedGroup } });
  }

  return (
    <>
      <Stack display={isDeleted && "none"}>
        <Flex alignItems={"center"} >

          <Box
            p="5px"
            border={`1px solid ${borderColor}`}
            m="6px"
            cursor={"pointer"}
            //onClick={() => navigate("/group")}
            onClick={() => setGroupSlideInfoModalOpen(true)}
          >
            <Text color={textColor4}>
              {`${group?.name} - ${
                group?.type === "free"
                  ? group?.type
                  : group?.plans && group?.plans?.length > 0
                  ? group?.plans.map((plan, i) => {
                      return `$${plan.price} / ${
                        plan.name === "lifetime"
                          ? "lifetime"
                          : plan.name === "monthly"
                          ? "Month"
                          : "Yearly"
                      }${i !== group?.plans?.length - 1 ? ", " : ""}`; // Add a space if not the last plan
                    })
                    .join(" ")
                  : ""
              } - ${nFormatter(group?.members?.length || 0)} members`}
            </Text>
          </Box>
            
          {authUser?.id == profileInfo?.id && <Box>
            <IoMdLink
            style={{ fontSize: "2em", cursor: "pointer", border:"1px solid #fff", borderRadius:"5px", padding:"1px" }}
            onClick={handleCopyToClipboard} 
            />
          </Box>}
            
          {authUser?.id == profileInfo?.id && 
          <Popover
            closeOnBlur={true}
          placement='right'
          >
              <PopoverTrigger>
                <Box ml="5px">
                  <IoMdSettings
                    style={{ fontSize: "2em", cursor: "pointer", border: "1px solid #fff", borderRadius: "5px", padding: "1px" }}
                  />
                </Box>
              </PopoverTrigger>
              <PopoverContent color='white' bg='#07182E' border='0' width={"100%"}>
                <PopoverArrow />
                <PopoverBody border='0'>
                  {/* Add your popover content here, e.g., a menu */}
                  <Stack
                      display='block'
                      alignItems='center'
                      justifyContent='space-between'
                  >
                    <Box fontSize='sm' textAlign={'center'} cursor={'pointer'}
                    onClick={() => setAddMembersModalOpen(true)} 
                    >Add New User</Box>

                    <Box fontSize='sm' textAlign={'center'} cursor={'pointer'}
                    onClick={() => {gotoGroupEdit(updatedGroup)}}
                    >Edit Group</Box>

                    <Box fontSize='sm' textAlign={'center'} cursor={'pointer'}
                    onClick={() => setShareGroupModalOpen(true)}
                    >
                      Share This Group
                    </Box>

                    <Box fontSize='sm' textAlign={'center'} color={'red'} cursor={'pointer'}
                    onClick={() => setDeleteGroupModalOpen(true)}
                    >Delete Group</Box>
                  </Stack>
                  
                </PopoverBody>
              </PopoverContent>
          </Popover>}

        </Flex>
      </Stack>
      
      <GroupSliderInfo groupData={updatedGroup} handleSubmit={handleSubmit} userInfo={authUser} isOpen={groupSlideInfoModalOpen} onClose={() => setGroupSlideInfoModalOpen(false)} />
      <AddMembersModal
        authUserId={authUser?.id} groupData={updatedGroup} otherUsers={otherUsers} 
        handleAddMember={handleAddMember} handleAddSingleMember={handleAddSingleMember}
        isOpen={addMembersModalOpen} onClose={() => setAddMembersModalOpen(false)} 
      />
      <DeleteGroupModal
        authUserId={authUser?.id} groupData={updatedGroup} handleGroupDelete={handleGroupDelete}
        isOpen={deleteGroupModalOpen} onClose={() => setDeleteGroupModalOpen(false)} setIsDeleted={setIsDeleted} 
      />
      <ShareGroupModal
        authUserId={authUser?.id} groupData={updatedGroup}
        isOpen={shareGroupModalOpen} onClose={() => setShareGroupModalOpen(false)} 
      />
    </>
  )
}

export default MyGroupCard